import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  TextField,
  Checkbox,
  InputAdornment,
  Divider
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Iconify from '../Iconify';
import { api } from 'src/Api';
import { NumericFormat } from 'react-number-format';

const BookingRate = ({
  BookingFormOpen,
  formData,
  errors,
  handleBookingFormOpen,
  handleChangevalue,
  handleCheckboxChangeCarriers,
  handleCheckboxChangeBirds,
  handleChangeRadioRequestType,
  handleCheckboxChangeAutoBid,
  disabled
}) => {
  const [spotRateData, setSpotRateData] = useState({});
  const [currentRateData, setCurrentRateData] = useState({});
  const [calculationData, setCalculationData] = useState({});
  const [calRateInput, setCalInputRate] = useState(0);

  useEffect(() => {
    getMarketRate();
  }, []);

  useEffect(() => {
    if (formData?.FL_DAT_value) {
      const calInputRate = formData?.FL_DAT_value / formData?.distance;
      setCalInputRate(calInputRate);
    } else {
      setCalInputRate(0);
    }
  }, [formData?.FL_DAT_value, formData.request_type]);

  useEffect(() => {
    if (spotRateData) {
      const perDayRate = spotRateData?.average_rate * formData.distance;
      const perDayRateMin = spotRateData?.min_rate * formData.distance;
      const perDayRateMax = spotRateData?.max_rate * formData.distance;
      setCalculationData({
        perDayRate: perDayRate,
        perDayRateMin: perDayRateMin,
        perDayRateMax: perDayRateMax
      });
    }
  }, [formData.distance, spotRateData]);

  function getMarketRate() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    // const queryParams = new URLSearchParams();
    // queryParams.append('miles', formData.distance);

    fetch(api.get_marketrates, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setSpotRateData(result.spot_rate);
          setCurrentRateData(result.contract_rate);
        } else {
          setCurrentRateData({});
          setSpotRateData({});
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  }

  return (
    <Box
      sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2 }}
      style={{
        borderRadius: 6,
        borderBottomLeftRadius: BookingFormOpen ? 6 : 6,
        borderBottomRightRadius: BookingFormOpen ? 6 : 6
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#010f58',
          height: 40,
          padding: '0px 15px 0px 15px'
        }}
        style={{
          borderRadius: 6,
          borderBottomLeftRadius: BookingFormOpen ? 0 : 6,
          borderBottomRightRadius: BookingFormOpen ? 0 : 6
        }}
        onClick={handleBookingFormOpen}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, fontSize: 13, textTransform: 'capitalize', color: '#ffffff' }}
        >
          Booking & Rate
        </Typography>
        {BookingFormOpen ? (
          <ExpandLess sx={{ color: '#ffffff' }} />
        ) : (
          <ExpandMore sx={{ color: '#ffffff' }} />
        )}
      </Box>

      <Box>
        <Collapse in={BookingFormOpen}>
          <Box
            sx={{ flexWrap: 'nowrap', padding: '0px 15px 20px 15px' }}
            style={{
              borderBottomLeftRadius: BookingFormOpen ? 6 : 0,
              borderBottomRightRadius: BookingFormOpen ? 6 : 0
            }}
          >
            <Box
              style={{
                border: '2px solid #010f58',
                marginTop: 20,
                marginBottom: 20,
                borderRadius: 7,
                padding: '30px 0px 30px 15px'
              }}
            >
              <Box style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <Checkbox
                  disabled={disabled}
                  checked={formData?.allow_carriers}
                  onChange={handleCheckboxChangeCarriers}
                  color="primary"
                  size="small"
                />
                <Box style={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 'bold', fontSize: 13 }}>
                    {'Allow carriers to book instantly (book now)'}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 12,
                      lineHeight: 1.3,
                      color: '#a9a9a9',
                      width: 380
                    }}
                  >
                    You will receive notifications within the Application when a new booking request
                    is received.
                  </Typography>
                </Box>
                {/* <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: 1.3,
                    color: '#a9a9a9',
                    marginRight: 5
                  }}
                >
                  Requires a rate
                </Typography> */}
              </Box>

              {errors.allow_carriers && (
                <Typography variant="caption" color="error" sx={{ marginLeft: 2 }}>
                  {errors.allow_carriers}
                </Typography>
              )}

              {formData?.allow_carriers && (
                <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 5, marginTop: 2 }}>
                  <RadioGroup
                    // sx={{ marginBottom: 1 }}
                    row
                    value={formData?.request_type}
                    onChange={handleChangeRadioRequestType}
                    name="requestType"
                  >
                    <FormControlLabel
                      disabled={disabled}
                      value="All"
                      control={<Radio size="small" />}
                      label={
                        <Typography style={{ fontSize: '12px', color: '#010f58' }}>
                          All Network
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      disabled={disabled}
                      value="Private"
                      control={<Radio size="small" />}
                      label={
                        <Typography style={{ fontSize: '12px', color: '#010f58' }}>
                          Private Network
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Box>
              )}
              {errors.request_type && formData?.allow_carriers && (
                <Typography variant="caption" color="error" sx={{ marginLeft: 7 }}>
                  {errors.request_type}
                </Typography>
              )}
            </Box>

            <Typography sx={{ fontWeight: 'bold', fontSize: 13, marginTop: 2 }}>
              Flat Rate
            </Typography>

            <Grid container>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: 13, marginTop: 2, marginBottom: 2 }}>
                  All Network
                </Typography>

                <TextField
                  disabled={disabled}
                  fullWidth
                  label="Rate / Trip"
                  name="FL_DAT_value"
                  value={formData.FL_DAT_value}
                  onChange={handleChangevalue}
                  error={Boolean(errors.FL_DAT_value)}
                  helperText={errors.FL_DAT_value}
                  type="number"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment sx={{ fontSize: 12 }} position="start">
                        $
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment sx={{ fontSize: 12 }} position="start">
                        / Trip
                      </InputAdornment>
                    ),
                    inputProps: {
                      style: { minWidth: '100px', textAlign: 'left', paddingLeft: '0px' } // minimum width and left alignment
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                  className="custom-textfield"
                />

                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginTop: 5
                  }}
                >
                  <Checkbox
                    disabled={disabled}
                    checked={formData?.allow_bids}
                    onChange={handleCheckboxChangeBirds}
                    color="primary"
                    size="small"
                  />
                  <Typography
                    sx={{
                      fontSize: 12,
                      lineHeight: 1.3,
                      marginRight: 5,
                      marginTop: 0.3
                    }}
                  >
                    Allow bids
                  </Typography>
                </Box>

                {formData?.allow_bids && (
                  <Box
                    style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                  >
                    <Checkbox
                      disabled={disabled}
                      checked={formData?.auto_bid_cancel}
                      onChange={handleCheckboxChangeAutoBid}
                      color="primary"
                      size="small"
                    />
                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        flex: 1
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 12
                        }}
                      >
                        Set Maximum Rate and automatically reject bids over this account
                      </Typography>
                    </Box>
                  </Box>
                )}

                {formData?.auto_bid_cancel && (
                  <Box sx={{ marginTop: 2, marginLeft: 2 }}>
                    <TextField
                      disabled={disabled ? true : formData?.auto_bid_cancel ? false : true}
                      fullWidth
                      label="Rate / Trip"
                      name="maximum_rate"
                      value={formData?.maximum_rate}
                      onChange={handleChangevalue}
                      error={Boolean(errors.maximum_rate)}
                      helperText={errors.maximum_rate}
                      type="number"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        endAdornment: (
                          <InputAdornment style={{ marginLeft: 5 }} position="start">
                            / Trip
                          </InputAdornment>
                        ),
                        inputProps: {
                          style: { minWidth: '100px', textAlign: 'left', paddingLeft: '0px' } // minimum width and left alignment
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                      className="custom-textfield"
                    />
                    <Typography sx={{ fontSize: 11, marginLeft: 2, marginTop: 0.5 }}>
                      {/* Maximum Rate should be greater than or equal to All Network Rate */}
                      Maximum Rate should be greater than or equal to Private Network Rate
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: 1, marginLeft: 2 }}>
                <Typography sx={{ fontSize: 14, marginTop: 2, marginBottom: 2 }}>
                  Market Rates
                </Typography>

                <Box style={{ border: '2px solid #F0F0F9' }}>
                  <Box
                    style={{
                      backgroundColor: '#F0F0F9',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '2px 10px 2px 10px'
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        fontWeight: 'bold',
                        letterSpacing: 1.5
                      }}
                    >
                      SPOT RATE
                    </Typography>
                    {formData?.origin && formData?.destination && (
                      <Typography
                        style={{
                          fontSize: 10,
                          color: '#000000'
                        }}
                      >
                        {formData?.origin.city} - {formData?.destination.city}
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    sx={{
                      fontSize: 10,
                      textAlign: 'end',
                      marginTop: 1,
                      marginRight: 1,
                      color: '#000000'
                    }}
                  >
                    {formData?.distance || 0} km | 30d average
                  </Typography>

                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '5px 10px 0px 10px'
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}>
                      Average rate :
                    </Typography>
                    <Typography
                      sx={{ fontSize: 14, textAlign: 'right', flex: 1, color: '#000000' }}
                    >
                      {spotRateData?.average_rate ? `$${spotRateData?.average_rate}/Km` : '0 /km'}
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '0px 10px 0px 10px'
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}>
                      Average rate range :
                    </Typography>
                    <Typography
                      sx={{ fontSize: 12, color: '#000000', textAlign: 'right', flex: 1 }}
                    >
                      {calculationData?.perDayRateMin || calculationData?.perDayRateMax
                        ? `$${calculationData?.perDayRateMin?.toFixed(
                            2
                          )}/Km - $${calculationData?.perDayRateMax?.toFixed(2)}/Km`
                        : '0 - 0'}
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '0px 10px 0px 10px'
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: '#999999' }}>
                      Average amount range :
                    </Typography>
                    <Typography
                      sx={{ fontSize: 12, color: '#000000', textAlign: 'right', flex: 1 }}
                    >
                      {spotRateData?.min_rate || spotRateData?.max_rate
                        ? `${spotRateData?.min_rate?.toFixed(
                            2
                          )} - ${spotRateData?.max_rate?.toFixed(2)}`
                        : '0 - 0 /km'}
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      backgroundColor: '#F0F0F9',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '2px 10px 2px 10px',
                      marginTop: 25
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        fontWeight: 'bold'
                      }}
                    >
                      FOR SHIPMENT RATE
                    </Typography>
                  </Box>

                  {formData.request_type ? (
                    <Box
                      sx={{
                        marginBottom: 3
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          textAlign: 'end',
                          marginTop: 1,
                          marginRight: 1,
                          color: '#000000',
                          marginBottom: 1
                        }}
                      >
                        {formData?.distance || '0'} km
                      </Typography>

                      <Box
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0px 10px 0px 10px'
                        }}
                      >
                        <Typography sx={{ fontSize: 12, color: '#999999' }}>Rate :</Typography>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#000000'
                          }}
                        >
                          <NumericFormat
                            value={calRateInput ? parseFloat(calRateInput).toFixed(2) : '0'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            style={{ color: '#000' }}
                          />
                        </Typography>
                      </Box>
                      <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                      <Box
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0px 10px 0px 10px'
                        }}
                      >
                        <Typography sx={{ fontSize: 12, color: '#999999' }}>
                          Total Amount :
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#000000',
                            textAlign: 'right',
                            flex: 1,
                            fontWeight: 'bold'
                          }}
                        >
                          ${formData?.FL_DAT_value ? formData?.FL_DAT_value : '0'}
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        marginLeft: 5,
                        marginTop: 3,
                        marginBottom: 3
                      }}
                    >
                      <>
                        <Iconify
                          sx={{ fontSize: 35, marginRight: 1 }}
                          icon={'system-uicons:box-open'}
                        />
                        <Typography
                          sx={{
                            fontSize: 12,
                            paddingBottom: 0.5,
                            marginTop: 0.8,
                            lineHeight: 1.3,
                            maxWidth: 252,
                            color: '#b4b4b4'
                          }}
                        >
                          Contract Rates are not avialable for this subscription
                        </Typography>
                      </>
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default BookingRate;
